import { render, staticRenderFns } from "./UpdateShipmentStatus.vue?vue&type=template&id=e4db9164&scoped=true"
import script from "./UpdateShipmentStatus.vue?vue&type=script&lang=js"
export * from "./UpdateShipmentStatus.vue?vue&type=script&lang=js"
import style0 from "./UpdateShipmentStatus.vue?vue&type=style&index=0&id=e4db9164&prod&scoped=true&lang=scss"
import style1 from "./UpdateShipmentStatus.vue?vue&type=style&index=1&id=e4db9164&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4db9164",
  null
  
)

export default component.exports